import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import AnimatedLogo from '../components/ui/AnimatedLogo';

const ClientPortal = () => {
  const [loginState, setLoginState] = useState('idle');
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    setLoginState('loading');
    
    // Simulate Authentication before redirecting to Enhanced Dashboard
    setTimeout(() => {
      setLoginState('success');
      navigate('/dashboard');
    }, 1500);
  };

  return (
    <div className="min-h-screen bg-white dark:bg-brand-dark flex items-center justify-center relative overflow-hidden px-6">
      <div 
        className="absolute inset-0 opacity-[0.15] pointer-events-none" 
        style={{ 
          backgroundImage: 'linear-gradient(to right,#40E0D0 1px,transparent 1px), linear-gradient(to bottom,#40E0D0 1px,transparent 1px)', 
          backgroundSize: '48px 48px',
          maskImage: 'radial-gradient(circle at center, transparent 0%, black 80%)',
          WebkitMaskImage: 'radial-gradient(circle at center, transparent 0%, black 80%)'
        }}
      ></div>
      
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md relative z-10"
      >
        <div className="text-center mb-8">
          <AnimatedLogo className="mb-4" useAvatar={true} size="sm" />
          <h1 className="text-3xl font-heading font-bold text-slate-900 dark:text-white mb-2">Example Client Portal</h1>
          <p className="text-[#008b8b] dark:text-brand-cyan text-sm tracking-widest uppercase font-bold mb-4">Secure Access</p>
          <p className="text-slate-600 dark:text-slate-400 text-sm font-medium leading-relaxed max-w-sm mx-auto">
            Experience complete transparency into your strategic operations. Track ROI, monitor unified data, and review AI orchestration workflows in real-time.
          </p>
        </div>

        <div className="bg-white/90 dark:bg-slate-900/80 backdrop-blur-xl border border-slate-200 dark:border-white/10 rounded-2xl p-8 shadow-2xl">
          <form onSubmit={handleLogin} className="space-y-6">
            <div>
              <label className="block text-xs uppercase tracking-widest text-slate-600 dark:text-slate-400 font-bold mb-2">Access Email</label>
              <div className="relative">
                <SafeIcon name="User" className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500 w-5 h-5" />
                <input 
                  type="email" 
                  required 
                  className="w-full bg-slate-50 dark:bg-brand-dark border-2 border-slate-300 dark:border-slate-700 pl-12 pr-4 py-3 focus:border-[#008b8b] dark:focus:border-brand-cyan outline-none transition-colors text-slate-900 dark:text-white rounded-lg"
                  placeholder="client@company.com"
                  defaultValue="executive@client.com"
                />
              </div>
            </div>

            <div>
              <label className="block text-xs uppercase tracking-widest text-slate-600 dark:text-slate-400 font-bold mb-2">Secure Passkey</label>
              <div className="relative">
                <SafeIcon name="Lock" className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500 w-5 h-5" />
                <input 
                  type="password" 
                  required 
                  className="w-full bg-slate-50 dark:bg-brand-dark border-2 border-slate-300 dark:border-slate-700 pl-12 pr-4 py-3 focus:border-[#008b8b] dark:focus:border-brand-cyan outline-none transition-colors text-slate-900 dark:text-white rounded-lg"
                  placeholder="••••••••••••"
                  defaultValue="password123"
                />
              </div>
            </div>

            <button 
              type="submit" 
              disabled={loginState === 'loading' || loginState === 'success'}
              className="w-full py-4 bg-[#008b8b] text-white dark:bg-brand-cyan dark:text-brand-dark text-sm uppercase tracking-widest font-bold hover:bg-[#007070] dark:hover:bg-[#33b8aa] transition-colors rounded-lg flex items-center justify-center gap-2 disabled:opacity-70"
            >
              {loginState === 'loading' ? 'Authenticating...' : loginState === 'success' ? 'Redirecting...' : 'Access Strategic Dashboard'}
              {loginState === 'idle' && <SafeIcon name="ArrowRight" className="w-4 h-4" />}
            </button>
          </form>

          <div className="mt-8 pt-6 border-t border-white/10 text-center">
            <p className="text-xs text-slate-500">
              Authorized access only. Activity is monitored.
            </p>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default ClientPortal;